import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { Wrench, Wallet, LogOut, HardHat, MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import useUnreadMessages from "@/hooks/useUnreadMessages";

export default function ProShell() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const msgUnread = useUnreadMessages();
  const nav = [
    { to: "/pro", icon: Wrench, label: "Missions" },
    { to: "/pro/gains", icon: Wallet, label: "Mes gains" },
    { to: "/messages", icon: MessageSquare, label: "Messages" },
  ];
  return (
    <div className="min-h-screen bg-[#111827] text-slate-100 pb-20">
      <header className="sticky top-0 z-40 bg-[#0F172A] border-b border-slate-700">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-[#E08B00] flex items-center justify-center text-[#0F172A] font-display font-black"><HardHat className="w-5 h-5" /></div>
            <div>
              <p className="font-display font-extrabold leading-none">Espace Pro</p>
              <p className="text-[11px] text-slate-400">{user?.name}</p>
            </div>
          </div>
          <button onClick={() => { logout(); navigate("/login"); }} className="text-slate-400 p-2" data-testid="pro-logout"><LogOut className="w-5 h-5" /></button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-5">
        <Outlet />
      </main>
      <nav className="fixed bottom-0 inset-x-0 bg-[#0F172A] border-t border-slate-700 flex max-w-3xl mx-auto">
        {nav.map((n) => {
          const active = location.pathname === n.to;
          return (
            <Link key={n.to} to={n.to} className="flex-1 flex flex-col items-center py-3" data-testid={`pronav-${n.label}`}>
              <span className="relative">
                <n.icon className={`w-5 h-5 ${active ? "text-[#E08B00]" : "text-slate-500"}`} />
                {n.to === "/messages" && msgUnread > 0 && <span className="absolute -top-1.5 -right-2 bg-[#DC2626] text-white text-[9px] rounded-full w-4 h-4 flex items-center justify-center">{msgUnread}</span>}
              </span>
              <span className={`text-[11px] mt-0.5 ${active ? "text-[#E08B00] font-semibold" : "text-slate-500"}`}>{n.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
